var map = {
	"./1000.png": 5048,
	"./2000.gif": 5506,
	"./2100.gif": 6691,
	"./2200.png": 6471,
	"./2300.png": 9782,
	"./3000.png": 7202,
	"./9999.png": 9063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3113;